import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=bd477b0c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd477b0c')) {
      api.createRecord('bd477b0c', component.options)
    } else {
      api.reload('bd477b0c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=bd477b0c", function () {
      api.rerender('bd477b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/import/general/edit.vue"
export default component.exports